module.exports = __webpack_public_path__ + "static/the-stone-cage-f1468ce5ff5a84bd72077ac2c34bda99.jpg";